import { graphql } from "~/gql";

export const CREATE_LIBRARY_ASSUMPTION = graphql(/* GraphQL */ `
  mutation CreateLibraryAssumption($data: LibraryAssumptionCreateInput!) {
    createLibraryAssumption(data: $data) {
      ...LibraryAssumptionFragment
    }
  }
`);
